import { render, staticRenderFns } from "./ReminderAutoList.vue?vue&type=template&id=51c68552&scoped=true"
import script from "./ReminderAutoList.vue?vue&type=script&lang=ts"
export * from "./ReminderAutoList.vue?vue&type=script&lang=ts"
import style0 from "./ReminderAutoList.vue?vue&type=style&index=0&id=51c68552&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c68552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c68552')) {
      api.createRecord('51c68552', component.options)
    } else {
      api.reload('51c68552', component.options)
    }
    module.hot.accept("./ReminderAutoList.vue?vue&type=template&id=51c68552&scoped=true", function () {
      api.rerender('51c68552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ReminderAutoList.vue"
export default component.exports